import request from '@/utils/request'

/**
 * 获取列表
 * @param {*} data
 */
function getPagelist(data) {
    return request({
      url: '/app/pdpaList',
      method: 'post',
      data
    })
}

/**
 * 新增
 * @param {*} data
 */
 function getAdd(data) {
    return request({
      url: '/app/insetUserPdpa',
      method: 'post',
      data
    })
}

/**
 * 修改
 * @param {*} data
 */
 function getUpdate(data) {
    return request({
      url: '/app/updateUserPdpa',
      method: 'post',
      data
    })
  }
  
/**
 * 获取content
 * @param {*} data 
 */
function getNewestPdpaInfo(){
  return request({
    url: '/app/getNewestPdpaInfo',
    method: 'post'
  })
}
/**
 * 根据id获取content
 * @param {*} data 
 */
 function getPdpaDetail(data){
  return request({
    url: `/app/getPdpaDetail`,
    method: 'post',
    data
  })
}
/**
 * 发布
 * @param {*} data 
 */
 function getfabu(data){
  return request({
    url: `/appUser/updatePdpaState`,
    method: 'post',
    data
  })
}
// 删除
function getdelete(id){
  return request({
    url: `/app/deletePdpa/${id}`,
    method: 'get'
  })
}
  export {
    getPagelist,
    getAdd,
    getUpdate,
    getNewestPdpaInfo,
    getPdpaDetail,
    getdelete,
    getfabu
  }